/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Users_Needed_TitleInputs */



/**
* | output |
* | --- |
* | "How many users do you need?" |
*
* @param {Pricing_Users_Needed_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_users_needed_title = /** @type {((inputs?: Pricing_Users_Needed_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Users_Needed_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wie viele Nutzer benötigen Sie?")
	return /** @type {LocalizedString} */ ("How many users do you need?")
});